import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as DayViewIcon } from "assets/icons/DayViewIco.svg";
import { ReactComponent as WeekViewIcon } from "assets/icons/WeekViewIco.svg";

import { VIEWS } from "utils/enums";
import { CalendarOutlined, ContainerOutlined, ReadOutlined } from "@ant-design/icons";

function ViewSelector({
  view,
  onView,
  views = [VIEWS.DAY, VIEWS.AGENDA, VIEWS.DISPATCH_LOG],
}) {
  return (
    <div className="viewSelector">
      {views.includes(VIEWS.DAY) && (
        <button
          onClick={() => onView(VIEWS.DAY)}
          className={`views ${view === VIEWS.DAY ? "active" : ""} `}
        >
          <DayViewIcon />
        </button>
      )}
      {views.includes(VIEWS.AGENDA) && (
        <button
          onClick={() => onView(VIEWS.AGENDA)}
          className={`views ${view === VIEWS.AGENDA ? "active" : ""} `}
        >
          <WeekViewIcon />
        </button>
      )}
      {/* {views.includes(VIEWS.DISPATCH_LOG) && (
        <button
          onClick={() => onView(VIEWS.DISPATCH_LOG)}
          className={`views ${view === VIEWS.DISPATCH_LOG ? "active" : ""} `}
        >
          <ReadOutlined size={36} style={{ fontSize: 21 }} />
        </button>
      )} */}
    </div>
  );
}

ViewSelector.propTypes = {};

export default ViewSelector;
